import React from "react";
import _ from "lodash";
import { renderLayout } from "schema/ThemeSet.react";
import MultiButton from "slides/components/MultiButton.react";
import OptionButton from "slides/components/OptionButton.react";

export default class MultipleSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOptions: [],
        };
    }

    handleOptionClick = (index) => {
        let list = this.state.selectedOptions;
        var idx = _.indexOf(list, index);
        if (idx !== -1) {
            list.splice(idx, 1);
        } else {
            list.push(index);
        }
        this.setState({ selectedOptions: list });
    };

    handleSubmit = () => {
        this.props.trackInteraction(this.state.selectedOptions);
    };

    render() {
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let LayoutRender = renderLayout(isPortrait, this.props.layout);

        let mappedOptions = _.map(
            this.props.data.multiselect,
            (option, index) => {
                return (
                    <MultiButton
                        {...this.props}
                        index={index}
                        key={"button-" + index}
                        name={"" + option.text}
                        selected={
                            this.state.selectedOptions.indexOf(index) > -1
                        }
                        handleClick={this.handleOptionClick}
                    />
                );
            }
        );
        let mainContent = (
            <div>
                {mappedOptions}
                <br />
                <br />
                <OptionButton
                    {...this.props}
                    secondary={true}
                    name="Submit"
                    handleClick={this.handleSubmit}
                />
            </div>
        );
        return (
            <div className="full-height">
                <LayoutRender
                    {...this.props}
                    title={"Choose all right options:"}
                    mainContent={mainContent}
                />
            </div>
        );
    }
}
